/**
 * Paths used by `reopen-table` feature. Allows in example conditionally redirection.
 */
export const REOPEN_TABLE_ORDERS_PATHS = ['orders'];
